import React from "react";
import L, { LatLngExpression } from "leaflet";
import SearchControl from "./SearchControl";
import MapEventLayer from "../utils/MapEventLayer";
import Map from "@/components/form-viewer/Map";
type LocationPickerMapProps = {
  initialPosition: L.LatLngExpression | null;
  locationPolygon: any;
  type: "static" | "dynamic" | undefined;
  markerRef: React.MutableRefObject<L.Marker | undefined>;
  markerGroupsRef: React.MutableRefObject<L.LayerGroup | undefined>;
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  showSearch?: boolean;
  disabled?: boolean;
};
const LocationPickerMap = ({
  initialPosition,
  locationPolygon,
  type,
  markerRef,
  markerGroupsRef,
  zoom,
  setZoom,
  showSearch,
  disabled
}: LocationPickerMapProps) => {
  return <Map center={initialPosition as LatLngExpression | undefined} zoom={zoom} maxZoom={17} markerZoomAnimation={true} style={{
    width: "100%",
    height: "100%"
  }} data-sentry-element="Map" data-sentry-component="LocationPickerMap" data-sentry-source-file="LocationPickerMap.tsx">
      {({
      TileLayer,
      GeoJSON
    }) => <>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
          {!!locationPolygon && type && <GeoJSON data={locationPolygon} />}

          <MapEventLayer type={type} markerRef={markerRef} markerGroupsRef={markerGroupsRef} setZoom={setZoom} locationPolygon={locationPolygon} disabled={disabled} />
          {showSearch && <SearchControl />}
        </>}
    </Map>;
};
export default LocationPickerMap;